//
// Module for the Participant Communication's Contact Logs view
//
rs.module("content/fund/account/seminars/attendancerules",

    [ "common/select-helper" ],

    function (selectHelper) {

        // Initialize the module
        function initialize(jsSelectors, codeValues, seminarIncludesEstimates) {

            // Unpack Js Selectors
            var form = $.js(jsSelectors.form);
            var participantTypeSelect = form.js(jsSelectors.participantTypeSelect);
            var memberTypeSelect = form.js(jsSelectors.memberTypeSelect);
            var memberTypeSelectHelper = selectHelper.getHelper(memberTypeSelect);
            var earliestRetirementDatePicker = form.js(jsSelectors.earliestRetirementDatePicker);

            participantTypeSelect.on("change", function () {
                var memberIsSelected = participantTypeSelect.val().includes(codeValues.member.toString());
                if (!memberIsSelected) {
                    memberTypeSelectHelper.setValue(null);
                    earliestRetirementDatePicker.val(null);
                    earliestRetirementDatePicker.prop("disabled", true);
                }
                memberTypeSelectHelper.setDisabled(!memberIsSelected);
            });

            memberTypeSelect.on("change", function () {
                if (seminarIncludesEstimates) {
                    var enableEarlierstRetirementDate = memberTypeSelect.val().includes(codeValues.active.toString())
                        || memberTypeSelect.val().includes(codeValues.deferred.toString())
                        || memberTypeSelect.val().includes(codeValues.inactive.toString());
                    earliestRetirementDatePicker.prop("disabled", !enableEarlierstRetirementDate);
                }
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);